export default [
	{value: [255, 255, 255], name: 'white'},
	{value: [0, 0, 0], name: 'black'},
	{value: [86, 65, 55], name: 'skin1'},
	{value: [31, 95, 181], name: 'blue'},
	{value: [59, 192, 103], name: 'green'},
	{value: [159, 103, 63], name: 'skin2'},
	{value: [225, 138, 0], name: 'orange'},
	{value: [144, 211, 242], name: 'lightblue'},
	{value: [197, 152, 114], name: 'skin3'},
	{value: [255, 8, 8], name: 'red'},
	{value: [254, 235, 43], name: 'yellow'},
	{value: [227, 194, 157], name: 'skin4'},
]

const buildColor = (value, opacity = 1) => `rgba(${value.join(',')},${opacity})`

export {
	buildColor,
}
